import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type ServiceInvoiceStatus = z.infer<typeof serviceInvoiceStatus>;
export const serviceInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  creditsForMonth: z.number(),
  creditsSpent: z.number(),
  billingDueDate: z.date(),
  estimatedInvoiceAmount: z.number(),
});

export const getCurrentMarketingEmailInvoice = {
  name: "getCurrentMarketingEmailInvoice" as const,
  input: z.null(),
  output: serviceInvoiceStatus.nullable(),
};
